export default __webpack_public_path__ + "static/media/webScreen.09b63718.png";